import React, { useState } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import type { SearchTopicalContentType } from '../../../components/SearchTopical/types';
import type { GenericParagraphEntity } from '../../../types/uncinc_profile/paragraphs';
import {
  SearchTopicalArticles,
  SearchTopicalEvents,
  Switch,
} from '../../../components';

import './style.scss';

export interface ParagraphTopicalProps {
  entity: ImmutableEntity<GenericParagraphEntity>;
  className?: string;
}

const ParagraphTopical: React.FC<ParagraphTopicalProps> = ({ entity, className }) => {
  const { t } = useTranslation();
  const { search } = useLocation();

  const paragraph = entity.toJS();
  const uuid = paragraph.uuid[0].value;

  const classNames = c('ParagraphTopical', className);

  const [currentTab, setCurrentTab] = useState<SearchTopicalContentType>(
    (new URLSearchParams(search).get('type') as SearchTopicalContentType) ?? 'event',
  );

  return (
    <div id={uuid} className={classNames}>
      <Switch
        className="ParagraphTopical__view-switch"
        currentTab={currentTab}
        onChange={(key) => setCurrentTab(key as SearchTopicalContentType)}
        tabs={[
          { key: 'event', label: t('components.search_topical.results.events'), icon: 'calendar_today' },
          { key: 'article', label: t('components.search_topical.results.articles'), icon: 'articles' },
        ]}
      />

      {currentTab === 'article' ? (
        <SearchTopicalArticles>
          <Container>
            <div className="row">
              <SearchTopicalArticles.Facets className="ParagraphTopical__facets">
                <div className="col-12 col-lg-3 mt-lg-1 order-1 order-lg-2">
                  <SearchTopicalArticles.AdvancedFacets />
                </div>
              </SearchTopicalArticles.Facets>

              <div className="col-12 col-lg-9 mt-12 mt-lg-1 order-3">
                <SearchTopicalArticles.ResultsArticles />
              </div>
            </div>
          </Container>
        </SearchTopicalArticles>
      ) : (
        <SearchTopicalEvents>
          <Container>
            <div className="row">
              <SearchTopicalEvents.Facets className="ParagraphTopical__facets">
                <div className="col-12 col-lg-3 mt-lg-1 order-1 order-lg-2">
                  <SearchTopicalEvents.AdvancedFacets />
                </div>
              </SearchTopicalEvents.Facets>

              <div className="col-12 col-lg-9 mt-12 mt-lg-1 order-3">
                <SearchTopicalEvents.ResultsEvents />
              </div>
            </div>
          </Container>
        </SearchTopicalEvents>
      )}
    </div>
  );
};

export default ParagraphTopical;
